import { PaymentMethodsProvider } from "@growthzilla/billingui";
import SubscriptionsSelect from "./SubscriptionsSelect";
import SignageBillingProvider from "../Billing/SignageBillingProvider";

function SubscriptionsSelectProvider() {
  return (
    <SignageBillingProvider>
      <PaymentMethodsProvider>
        <SubscriptionsSelect />
      </PaymentMethodsProvider>
    </SignageBillingProvider>
  );
}
export default SubscriptionsSelectProvider;
